import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const ClassroomObservationsByLeaders = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Classroom observations by leaders" />
    </Box>
  );
};
